import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';

import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { base_url, Apitoken, Authtoken } from "../Global";
import { MaterialReactTable } from 'material-react-table';

import Swal from 'sweetalert2';
//Material UI Imports
import {

  MenuItem,

} from '@mui/material';

import { useRef } from 'react'; // Add this at the top of your file

const Expenses = () => {

  const topScrollRef = useRef(null);
  const tableContainerRef = useRef(null);
  const [tableWidth, setTableWidth] = useState(0);

  useEffect(() => {
    const topScroll = topScrollRef.current;
    const tableContainer = tableContainerRef.current;

    if (!topScroll || !tableContainer) return;

    // Set the width of the top scrollbar to match table content width
    const table = tableContainer.querySelector('table');
    if (table) {
      setTableWidth(table.scrollWidth);
    }

    // Sync top scrollbar with table scroll
    const handleTableScroll = () => {
      topScroll.scrollLeft = tableContainer.scrollLeft;
    };

    // Sync table scroll with top scrollbar
    const handleTopScroll = () => {
      tableContainer.scrollLeft = topScroll.scrollLeft;
    };

    tableContainer.addEventListener('scroll', handleTableScroll);
    topScroll.addEventListener('scroll', handleTopScroll);

    return () => {
      tableContainer.removeEventListener('scroll', handleTableScroll);
      topScroll.removeEventListener('scroll', handleTopScroll);
    };
  }, []);

  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [permission, setPermission] = useState({});
  let season_id = localStorage.getItem("season_id");
  let para = { season_id: season_id };
  useEffect(() => {
    setPermission(FindModuleById(271));
    console.log(permission);

    axios.post("/expenses/listing", para, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
      .then((response) => {

        if (response.data.code === 200) {
          setData(response.data.data.expenses);
        }
        else if (response.data.code === 401) {
          window.location.href = "/login";
        } else {
          window.location.href = "/login";
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);


  const editItem = (item) => {
    window.location.href = "/expenses-edit/" + item;
  }
  const viewItem = (item) => {
    window.location.href = "/expenses-view/" + item;
  }

  const deleteItem = (item) => {
    let season_id = localStorage.getItem("season_id");
    Swal.fire({
      title: 'Do you really want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/expenses/delete/${season_id + '-' + item}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
          .then((response) => {
            console.log(response);
            if (response.data.code === 200) {
              Swal.fire(
                'Deleted!',
                'Your Record has been deleted.',
                'success'
              );
              setTimeout(() => {
                window.location.href = "/expenses";
              }, 500);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  }

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const InvoiceNumberCell = ({ row }) => (
    <button className="btn" style={{ color: "#709506" }} onClick={() => addExpenseData(row.original.id, row.original)}>
      {row.original.invoice_number}
    </button>
  );

  InvoiceNumberCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        invoice_number: PropTypes.string.isRequired,
      }),
    }).isRequired,
  };


  const DueDateCell = ({ row }) => {
    const dueDate = row.original.invoice_due_date;
    if (!dueDate) return '';



    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const due = new Date(dueDate);
    due.setHours(0, 0, 0, 0);

    const diffTime = due - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    // Show in red if due date is in the FUTURE and within next 7 days
    // diffDays > 0 means future date, diffDays <= 7 means within 7 days
    const isUrgent = diffDays <= 7;

    return (
      <span style={{ color: isUrgent ? 'red' : 'inherit', fontWeight: isUrgent ? 'bold' : 'normal' }}>
        {dueDate}
      </span>
    );
  };

  DueDateCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        invoice_due_date: PropTypes.string,
        payment_status: PropTypes.string,

      }),
    }).isRequired,
  };

  // const TVARateCell = ({ row }) => {
  //   const tvaRate = row.original.tva_rate;
  //   const otherTvaRate = row.original.other_tva_rate;

  //   // If tva_rate is 111, show other_tva_rate, otherwise show tva_rate
  //   const displayValue = tvaRate === 111 ? otherTvaRate : tvaRate;

  //   return <span>{displayValue || ''}</span>;
  // };

  // TVARateCell.propTypes = {
  //   row: PropTypes.shape({
  //     original: PropTypes.shape({
  //       tva_rate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  //       other_tva_rate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  //     }),
  //   }).isRequired,
  // };

  const PaymentStatusCell = ({ row }) => {
    const paymentStatus = row.original.payment_status;
    if (!paymentStatus) return '';

    const isPaid = paymentStatus.toUpperCase() === 'PAID';

    return (
      <span style={{
        color: isPaid ? 'green' : 'inherit',
        fontWeight: isPaid ? 'bold' : 'normal'
      }}>
        {paymentStatus}
      </span>
    );
  };

  PaymentStatusCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        payment_status: PropTypes.string,
      }),
    }).isRequired,
  };

  const columns =
    [
      {
        header: 'Type',
        accessorFn: (row) => `${(row.type == 2) ? 'Credit Note' : "Invoice"} `,
      },
      {
        header: "Invoice Number",
        accessorKey: 'invoice_number',
        Cell: InvoiceNumberCell,
      },


      {
        accessorKey: 'invoice_date',
        header: 'Invoice Date',
      },
      {
        // accessorKey: 'supplier', 
        header: "Supplier's Name",
        accessorFn: (row) => `${(row.supplier_detail) ? row.supplier_detail.name : ""} `,
      },

      {
        header: 'Total Amount TTC',
        accessorFn: (row) => `${(row.type == 1) ? row.total_amount : "-" + row.total_amount} `,
      },


      {
        accessorKey: 'expense_type',
        header: 'Expense Type',
      },


      {
        accessorKey: 'expense_type_extention',
        header: 'Expense Type Extention',
      },
      {
        accessorKey: 'invoice_due_date',
        header: 'Due Date',
        Cell: DueDateCell,
      },

      {
        accessorKey: 'payment_status',
        header: 'Payment Status',
        Cell: PaymentStatusCell, // ✅ Custom cell component for payment status
      },
      {
        accessorKey: 'payment_date',
        header: 'Payment Date',
      },
      {
        accessorKey: 'payment_method',
        header: 'Payment Method',
      },
      {
        header: 'Bank',
        accessorFn: (row) => `${(row.bank_detail) ? row.bank_detail.title : ""} `,
      },
      {
        accessorKey: 'if',
        header: 'IF',
      },
      {
        accessorKey: 'ice',
        header: 'ICE',
      },
      {
        header: 'Created By',
        accessorFn: (row) => `${(row.createdby) ? row.createdby.first_name + ' ' + row.createdby.last_name : ""} `,
      },
      {
        header: 'Updated By',
        accessorFn: (row) => `${(row.updatedby) ? row.updatedby.first_name + ' ' + row.updatedby.last_name : ""} `,
      },
    ];


  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const defaultDate = (formatDate(new Date()));



  // const addExpenseData = async (id) => {
  //   const { value: formValues } = await Swal.fire({
  //     title: 'Payment Situation',
  //     html: `
  //       <div style="display:grid">     
  //         <label style="text-align: left; padding-left: 6px; margin-bottom:3px; display: block;">
  //           Payment Date
  //         </label>      
  //         <input type="date" id="payment_date" class="swal2-input" value="${defaultDate}" placeholder="Select Date">

  //         <label style="text-align: left; padding-left: 6px; margin-bottom:3px; display: block;">
  //           Payment Method
  //         </label>      
  //         <select name="payment_method" class="swal2-select" id="payment_method">
  //           <option value="">Select</option>
  //           <option value="Bank Transfer">Bank Transfer</option>
  //           <option value="Cheque">Cheque</option>
  //           <option value="Lettre De Change">Lettre De Change</option>
  //           <option value="Cash">Cash</option>
  //         </select>    

  //         <label class="bank_option" style="text-align: left; padding-left: 6px; margin-bottom:3px; display: none;">
  //           Select Bank
  //         </label>      
  //         <select name="bank" class="swal2-select bank_option" id="bank" style="display: none;">
  //           <option value="">Select</option>
  //           <option value="1">BMCE EO</option>
  //           <option value="2">Credit Agricole EO</option>
  //           <option value="4">Caixha Bank</option>
  //         </select>  

  //         <label style="text-align: left; padding-left: 6px; margin-bottom:3px; display: block;">
  //           Payment Note
  //         </label> 
  //         <textarea name="payment_note" id="payment_note" class="swal2-textarea" placeholder="Payment Note"></textarea>
  //       </div>
  //       `,   
  //     showCancelButton: true,
  //     confirmButtonText: 'Update',
  //     cancelButtonText: 'Cancel',
  //     customClass: "swal-orders",
  //     didOpen: () => {
  //       // Adding event listener to payment method dropdown
  //       const paymentMethod = document.getElementById('payment_method');
  //       const bankOptionLabels = document.querySelectorAll('.bank_option');

  //       paymentMethod.addEventListener('change', (event) => {
  //         if (event.target.value === 'Bank Transfer') {
  //           bankOptionLabels.forEach((el) => el.style.display = 'block');
  //         } else {
  //           bankOptionLabels.forEach((el) => el.style.display = 'none');
  //         }
  //       });
  //     },
  //     preConfirm: () => {
  //       const payment_date = document.getElementById('payment_date').value;
  //       const payment_method = document.getElementById('payment_method').value;
  //       const bank = document.getElementById('bank').value;
  //       const payment_note = document.getElementById('payment_note').value;


  //       if (!payment_date) {
  //         Swal.showValidationMessage('Payment Date is required');
  //         return null;
  //       }
  //       if (!payment_method) {
  //         Swal.showValidationMessage('Payment Method is required');
  //         return null;
  //       }


  //       return { id, payment_date, payment_method,bank,  payment_note };
  //     }
  //   });

  //   if (formValues) {
  //     try {
  //         let season_id = localStorage.getItem("season_id");

  //       const response = await axios.post(`/expenses/add-payment`, {
  //         expense_id: formValues.id,
  //         season_id: season_id,
  //         payment_date: formValues.payment_date,
  //         bank: formValues.bank,
  //         payment_method: formValues.payment_method,
  //         payment_note: formValues.payment_note
  //       }, {
  //         headers: {
  //           Authorization: `Bearer ${Authtoken}`,
  //           Apitoken: Apitoken
  //         },
  //       });


  //       if (response.data.code === 200) {
  //         Swal.fire(
  //           'Successfully!',
  //           'Payment Added Successfully.',
  //           'success'
  //         );
  //         axios.post("/expenses/listing",para,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
  //         .then((response) => {

  //           if (response.data.code === 200) {
  //             setData(response.data.data.expenses);
  //           }
  //           else  if (response.data.code === 401) {
  //             window.location.href = "/login";
  //           }else{
  //             window.location.href = "/login"; 
  //           }
  //         })
  //         .catch((error) => {
  //           console.log(error);
  //         });
  //       }
  //     } catch (error) {
  //       Swal.fire(
  //         'Error!',
  //         'There was a problem Payment Addming',
  //         'error'
  //       );
  //     }
  //   }
  // };


  const addExpenseData = async (id, rowData = {}) => {

  const existingPaymentDate = rowData.payment_date || defaultDate;
  const existingPaymentMethod = rowData.payment_method || '';
  const existingBank = rowData.bank_detail ? rowData.bank_detail.id : '';
  const existingPaymentNote = rowData.payment_note || '';

  const { value: formValues } = await Swal.fire({
    title: 'Payment Situation',
    html: `
      <div style="display:grid">     
        <label style="text-align: left; padding-left: 6px; margin-bottom:3px; display: block;">
          Payment Date
        </label>      
        <input type="date" id="payment_date" class="swal2-input" value="${existingPaymentDate}" placeholder="Select Date">

        <label style="text-align: left; padding-left: 6px; margin-bottom:3px; display: block;">
          Payment Method
        </label>      
        <select name="payment_method" class="swal2-select" id="payment_method">
          <option value="">Select</option>
          <option value="Bank Transfer" ${existingPaymentMethod === 'Bank Transfer' ? 'selected' : ''}>Bank Transfer</option>
          <option value="Cheque" ${existingPaymentMethod === 'Cheque' ? 'selected' : ''}>Cheque</option>
          <option value="Lettre De Change" ${existingPaymentMethod === 'Lettre De Change' ? 'selected' : ''}>Lettre De Change</option>
          <option value="Cash" ${existingPaymentMethod === 'Cash' ? 'selected' : ''}>Cash</option>
        </select>    
        
        <label class="bank_option" style="text-align: left; padding-left: 6px; margin-bottom:3px; display: ${existingPaymentMethod === 'Bank Transfer' ? 'block' : 'none'};">
          Select Bank
        </label>      
        <select name="bank" class="swal2-select bank_option" id="bank" style="display: ${existingPaymentMethod === 'Bank Transfer' ? 'block' : 'none'};">
          <option value="">Select</option>
          <option value="1" ${existingBank == '1' ? 'selected' : ''}>BMCE EO</option>
          <option value="2" ${existingBank == '2' ? 'selected' : ''}>Credit Agricole EO</option>
          <option value="4" ${existingBank == '4' ? 'selected' : ''}>Caixha Bank</option>
        </select>  

        <label style="text-align: left; padding-left: 6px; margin-bottom:3px; display: block;">
          Payment Note
        </label> 
        <textarea name="payment_note" id="payment_note" class="swal2-textarea" placeholder="Payment Note">${existingPaymentNote}</textarea>
      </div>
      `,
    showCancelButton: true,
    confirmButtonText: 'Update',
    cancelButtonText: 'Cancel',
    customClass: "swal-orders",

    didOpen: () => {
      const paymentMethod = document.getElementById('payment_method');
      const bankOptionLabels = document.querySelectorAll('.bank_option');

      // ✅ Create Reset button and inject BEFORE the Update (confirm) button
      const resetBtn = document.createElement('button');
      resetBtn.innerText = 'Reset';
      resetBtn.type = 'button';
      resetBtn.style.cssText = `
        background: #f0ad4e;
        color: white;
        border: none;
        padding: 8px 20px;
        border-radius: 4px;
        cursor: pointer;
        font-size: 14px;
      `;

      // ✅ Get the actions container and confirm button, insert Reset before confirm
      const actionsContainer = Swal.getActions();
      const confirmButton = Swal.getConfirmButton();
      actionsContainer.insertBefore(resetBtn, confirmButton);

      // ✅ Payment method change handler to show/hide bank dropdown
      paymentMethod.addEventListener('change', (event) => {
        if (event.target.value === 'Bank Transfer') {
          bankOptionLabels.forEach((el) => el.style.display = 'block');
        } else {
          bankOptionLabels.forEach((el) => el.style.display = 'none');
        }
      });

      // ✅ Reset button click handler
      resetBtn.addEventListener('click', async () => {
        const confirmReset = await Swal.fire({
          title: 'Are you sure?',
          text: 'This will reset all the payment fields.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, Reset',
          cancelButtonText: 'No, Keep it',
          confirmButtonColor: '#f0ad4e',
          cancelButtonColor: '#3085d6',
        });

        if (confirmReset.isConfirmed) {
          try {
            let season_id = localStorage.getItem("season_id");

            const resetResponse = await axios.post(`/expenses/reset-payment`, {
              expense_id: id,
              season_id: season_id,
              payment_date: '',
              payment_method: '',
              bank: '',
              payment_note: ''
            }, {
              headers: {
                Authorization: `Bearer ${Authtoken}`,
                Apitoken: Apitoken
              },
            });

            if (resetResponse.data.code === 200) {
              Swal.fire('Successfully!', 'Payment Reset Successfully.', 'success');

              axios.post("/expenses/listing", para, {
                headers: {
                  Authorization: `Bearer ${Authtoken}`,
                  Apitoken: Apitoken
                },
              })
                .then((response) => {
                  if (response.data.code === 200) {
                    setData(response.data.data.expenses);
                  } else if (response.data.code === 401) {
                    window.location.href = "/login";
                  } else {
                    window.location.href = "/login";
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            } else {
              Swal.fire('Error!', 'Reset failed. Please try again.', 'error');
            }

          } catch (error) {
            console.error('Reset API error:', error);
            Swal.fire('Error!', 'There was a problem resetting the payment.', 'error');
          }
        }
      });
    },

    preConfirm: () => {
      const payment_date = document.getElementById('payment_date').value;
      const payment_method = document.getElementById('payment_method').value;
      const bank = document.getElementById('bank').value;
      const payment_note = document.getElementById('payment_note').value;

      if (!payment_date) {
        Swal.showValidationMessage('Payment Date is required');
        return null;
      }
      if (!payment_method) {
        Swal.showValidationMessage('Payment Method is required');
        return null;
      }

      return { id, payment_date, payment_method, bank, payment_note };
    }
  });

  // ✅ Handle Update form submission
  if (formValues) {
    try {
      let season_id = localStorage.getItem("season_id");

      const response = await axios.post(`/expenses/add-payment`, {
        expense_id: formValues.id,
        season_id: season_id,
        payment_date: formValues.payment_date,
        bank: formValues.bank,
        payment_method: formValues.payment_method,
        payment_note: formValues.payment_note
      }, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken
        },
      });

      if (response.data.code === 200) {
        Swal.fire('Successfully!', 'Payment Added Successfully.', 'success');

        axios.post("/expenses/listing", para, {
          headers: {
            Authorization: `Bearer ${Authtoken}`,
            Apitoken: Apitoken
          },
        })
          .then((response) => {
            if (response.data.code === 200) {
              setData(response.data.data.expenses);
            } else if (response.data.code === 401) {
              window.location.href = "/login";
            } else {
              window.location.href = "/login";
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } catch (error) {
      Swal.fire('Error!', 'There was a problem adding the payment.', 'error');
    }
  }
};

  // const addExpenseData = async (id, rowData ) => {


  // // ✅ Pre-fill values from row data
  // const existingPaymentDate = rowData.payment_date || defaultDate;
  // const existingPaymentMethod = rowData.payment_method || '';
  // const existingBank = rowData.bank_detail ? rowData.bank_detail.id : '';
  // const existingPaymentNote = rowData.payment_note || '';

  //   const { value: formValues } = await Swal.fire({
  //     title: 'Payment Situation',
  //     // html: `
  //     //   <div style="display:grid">     
  //     //     <label style="text-align: left; padding-left: 6px; margin-bottom:3px; display: block;">
  //     //       Payment Date
  //     //     </label>      
  //     //     <input type="date" id="payment_date" class="swal2-input" value="${defaultDate}" placeholder="Select Date">

  //     //     <label style="text-align: left; padding-left: 6px; margin-bottom:3px; display: block;">
  //     //       Payment Method
  //     //     </label>      
  //     //     <select name="payment_method" class="swal2-select" id="payment_method">
  //     //       <option value="">Select</option>
  //     //       <option value="Bank Transfer">Bank Transfer</option>
  //     //       <option value="Cheque">Cheque</option>
  //     //       <option value="Lettre De Change">Lettre De Change</option>
  //     //       <option value="Cash">Cash</option>
  //     //     </select>    
          
  //     //     <label class="bank_option" style="text-align: left; padding-left: 6px; margin-bottom:3px; display: none;">
  //     //       Select Bank
  //     //     </label>      
  //     //     <select name="bank" class="swal2-select bank_option" id="bank" style="display: none;">
  //     //       <option value="">Select</option>
  //     //       <option value="1">BMCE EO</option>
  //     //       <option value="2">Credit Agricole EO</option>
  //     //       <option value="4">Caixha Bank</option>
  //     //     </select>  

  //     //     <label style="text-align: left; padding-left: 6px; margin-bottom:3px; display: block;">
  //     //       Payment Note
  //     //     </label> 
  //     //     <textarea name="payment_note" id="payment_note" class="swal2-textarea" placeholder="Payment Note"></textarea>
  //     //   </div>
  //     //   `,
  //     html: `
  //     <div style="display:grid">     
  //       <label style="text-align: left; padding-left: 6px; margin-bottom:3px; display: block;">
  //         Payment Date
  //       </label>      
  //       <input type="date" id="payment_date" class="swal2-input" value="${existingPaymentDate}" placeholder="Select Date">

  //       <label style="text-align: left; padding-left: 6px; margin-bottom:3px; display: block;">
  //         Payment Method
  //       </label>      
  //       <select name="payment_method" class="swal2-select" id="payment_method">
  //         <option value="">Select</option>
  //         <option value="Bank Transfer" ${existingPaymentMethod === 'Bank Transfer' ? 'selected' : ''}>Bank Transfer</option>
  //         <option value="Cheque" ${existingPaymentMethod === 'Cheque' ? 'selected' : ''}>Cheque</option>
  //         <option value="Lettre De Change" ${existingPaymentMethod === 'Lettre De Change' ? 'selected' : ''}>Lettre De Change</option>
  //         <option value="Cash" ${existingPaymentMethod === 'Cash' ? 'selected' : ''}>Cash</option>
  //       </select>    
        
  //       <label class="bank_option" style="text-align: left; padding-left: 6px; margin-bottom:3px; display: ${existingPaymentMethod === 'Bank Transfer' ? 'block' : 'none'};">
  //         Select Bank
  //       </label>      
  //       <select name="bank" class="swal2-select bank_option" id="bank" style="display: ${existingPaymentMethod === 'Bank Transfer' ? 'block' : 'none'};">
  //         <option value="">Select</option>
  //         <option value="1" ${existingBank == '1' ? 'selected' : ''}>BMCE EO</option>
  //         <option value="2" ${existingBank == '2' ? 'selected' : ''}>Credit Agricole EO</option>
  //         <option value="4" ${existingBank == '4' ? 'selected' : ''}>Caixha Bank</option>
  //       </select>  

  //       <label style="text-align: left; padding-left: 6px; margin-bottom:3px; display: block;">
  //         Payment Note
  //       </label> 
  //       <textarea name="payment_note" id="payment_note" class="swal2-textarea" placeholder="Payment Note">${existingPaymentNote}</textarea>
  //     </div>
  //     `,
  //     showCancelButton: true,
  //     confirmButtonText: 'Update',
  //     cancelButtonText: 'Cancel',
  //     customClass: "swal-orders",

  //     footer: `<button id="reset_btn" style="
  //         background: #f0ad4e;
  //         color: white;
  //         border: none;
  //         padding: 8px 20px;
  //         border-radius: 4px;
  //         cursor: pointer;
  //         font-size: 14px;
  //         margin-top: -10px;
  //       ">Reset</button>`,

  //     didOpen: () => {
  //       const paymentMethod = document.getElementById('payment_method');
  //       const bankOptionLabels = document.querySelectorAll('.bank_option');

  //       // ✅ Payment method change handler to show/hide bank dropdown
  //       paymentMethod.addEventListener('change', (event) => {
  //         if (event.target.value === 'Bank Transfer') {
  //           bankOptionLabels.forEach((el) => el.style.display = 'block');
  //         } else {
  //           bankOptionLabels.forEach((el) => el.style.display = 'none');
  //         }
  //       });

  //       // ✅ Reset button click handler
  //       document.getElementById('reset_btn').addEventListener('click', async () => {
  //         const confirmReset = await Swal.fire({
  //           title: 'Are you sure?',
  //           text: 'This will reset all the payment fields.',
  //           icon: 'warning',
  //           showCancelButton: true,
  //           confirmButtonText: 'Yes, Reset',
  //           cancelButtonText: 'No, Keep it',
  //           confirmButtonColor: '#f0ad4e',
  //           cancelButtonColor: '#3085d6',
  //         });

  //         if (confirmReset.isConfirmed) {
  //           try {
  //             let season_id = localStorage.getItem("season_id");

  //             // ✅ Send reset data to API with id and empty values
  //             const resetResponse = await axios.post(`/expenses/reset-payment`, {
  //               expense_id: id,
  //               season_id: season_id,
  //               payment_date: '',
  //               payment_method: '',
  //               bank: '',
  //               payment_note: ''
  //             }, {
  //               headers: {
  //                 Authorization: `Bearer ${Authtoken}`,
  //                 Apitoken: Apitoken
  //               },
  //             });

  //             console.log(resetResponse);

  //             if (resetResponse.data.code === 200) {
  //               Swal.fire('Successfully!', 'Payment Reset Successfully.', 'success');

  //               // ✅ Refresh the expenses listing after successful payment
  //               axios.post("/expenses/listing", para, {
  //                 headers: {
  //                   Authorization: `Bearer ${Authtoken}`,
  //                   Apitoken: Apitoken
  //                 },
  //               })
  //                 .then((response) => {
  //                   if (response.data.code === 200) {
  //                     setData(response.data.data.expenses);
  //                   } else if (response.data.code === 401) {
  //                     window.location.href = "/login";
  //                   } else {
  //                     window.location.href = "/login";
  //                   }
  //                 })
  //                 .catch((error) => {
  //                   console.log(error);
  //                 });
  //             } else {
  //               Swal.fire('Error!', 'Reset failed. Please try again.', 'error');
  //             }

  //           } catch (error) {
  //             console.error('Reset API error:', error);
  //             Swal.fire('Error!', 'There was a problem resetting the payment.', 'error');
  //           }
  //         }
  //       });
  //     },

  //     preConfirm: () => {
  //       const payment_date = document.getElementById('payment_date').value;
  //       const payment_method = document.getElementById('payment_method').value;
  //       const bank = document.getElementById('bank').value;
  //       const payment_note = document.getElementById('payment_note').value;

  //       if (!payment_date) {
  //         Swal.showValidationMessage('Payment Date is required');
  //         return null;
  //       }
  //       if (!payment_method) {
  //         Swal.showValidationMessage('Payment Method is required');
  //         return null;
  //       }

  //       return { id, payment_date, payment_method, bank, payment_note };
  //     }
  //   });

  //   // ✅ Handle Update form submission
  //   if (formValues) {
  //     try {
  //       let season_id = localStorage.getItem("season_id");

  //       const response = await axios.post(`/expenses/add-payment`, {
  //         expense_id: formValues.id,
  //         season_id: season_id,
  //         payment_date: formValues.payment_date,
  //         bank: formValues.bank,
  //         payment_method: formValues.payment_method,
  //         payment_note: formValues.payment_note
  //       }, {
  //         headers: {
  //           Authorization: `Bearer ${Authtoken}`,
  //           Apitoken: Apitoken
  //         },
  //       });

  //       if (response.data.code === 200) {
  //         Swal.fire('Successfully!', 'Payment Added Successfully.', 'success');

  //         // ✅ Refresh the expenses listing after successful payment
  //         axios.post("/expenses/listing", para, {
  //           headers: {
  //             Authorization: `Bearer ${Authtoken}`,
  //             Apitoken: Apitoken
  //           },
  //         })
  //           .then((response) => {
  //             if (response.data.code === 200) {
  //               setData(response.data.data.expenses);
  //             } else if (response.data.code === 401) {
  //               window.location.href = "/login";
  //             } else {
  //               window.location.href = "/login";
  //             }
  //           })
  //           .catch((error) => {
  //             console.log(error);
  //           });
  //       }
  //     } catch (error) {
  //       Swal.fire('Error!', 'There was a problem adding the payment.', 'error');
  //     }
  //   }
  // };


  const downloadExcel = (e) => {
    console.log(e)
    let season_id = localStorage.getItem("season_id");
    window.open(`${base_url}/expenses/listing-excel?season_id=${season_id}`, '_blank');
  }
  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Expenses</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Expenses</li>
                </ul>
              </div>
              <div className="col-auto">
                <button
                  className="btn btn-primary"
                  onClick={() => downloadExcel()}
                >
                  <i className="fa fa-file-excel-o"></i>  <i className="fa fa-download"></i>
                </button>
                &nbsp;&nbsp;
                {permission?.add == 1 && (
                  <Link to="/expenses-add" className="btn btn-primary me-1">
                    <i className="fas fa-plus"></i>
                  </Link>
                )}


              </div>
            </div>
          </div>

          <div className="row">

            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  <div className="table-responsive">
                    <div
                      ref={topScrollRef}
                      style={{
                        overflowX: 'auto',
                        overflowY: 'hidden',
                        height: '17px',
                        marginBottom: '8px',
                        border: '1px solid #e0e0e0',
                        borderRadius: '4px'
                      }}
                    >
                      <div style={{ width: `${tableWidth}px`, height: '1px' }} />
                    </div>

                    {permission?.list == 1 && (
                      <MaterialReactTable columns={columns} data={data}
                        // enableColumnFilterModes
                        enableColumnOrdering
                        // enableGrouping
                        enablePinning
                        enableRowActions
                        // enableRowSelection
                        // initialState={{ showColumnFilters: true }}
                        renderRowActionMenuItems={({ row }) => [
                          permission?.update == 1 && (
                            <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                              Edit
                            </MenuItem>
                          ),
                          permission?.update == 1 && (
                            <MenuItem key="view" onClick={() => viewItem(row.original.id)}>
                              View
                            </MenuItem>
                          ),
                          permission?.delete == 1 && (
                            <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                              Delete
                            </MenuItem>
                          ),
                        ]}
                        muiTableContainerProps={{
                          ref: tableContainerRef,
                          // REMOVE the sx prop with rotateX - it prevents dual scrollbars
                        }}

                      />
                    )}

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Expenses;
